var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "soc-process-rail", attrs: { role: "list" } },
    _vm._l(_vm.nodes, function(node, i) {
      return _c(
        "div",
        { key: node.id || i, staticClass: "soc-process-rail__item" },
        [
          _c(
            "button",
            {
              staticClass: "soc-process-rail__node",
              class: _vm.nodeClass(node),
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("select", node)
                }
              }
            },
            [
              _c("span", { staticClass: "soc-process-rail__mark" }, [
                _vm._v(_vm._s(_vm.markFor(node, i)))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "soc-process-rail__title" }, [
                _vm._v(_vm._s(node.title))
              ]),
              _vm._v(" "),
              node.statusLabel
                ? _c("span", { staticClass: "soc-process-rail__status" }, [
                    _vm._v(_vm._s(node.statusLabel))
                  ])
                : node.stuck
                ? _c("span", { staticClass: "soc-process-rail__now" }, [
                    _vm._v(_vm._s(_vm.nowLabel))
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          i < _vm.nodes.length - 1
            ? _c("span", {
                staticClass: "soc-process-rail__line",
                class: { "is-done": node.done },
                attrs: { "aria-hidden": "true" }
              })
            : _vm._e()
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c07bfca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c07bfca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocProcessRail.vue
// module id = null
// module chunks = 